import moment from 'moment';
import { isNullOrUndefined } from '../../store/storeFunctions';

function customParseDate(str, format, locale) {
    let m = moment(str, format, locale, true);
    
    if (!m.isValid()) m = moment(str, 'D.M.YYYY', locale, true);
    if (!m.isValid()) m = moment(str, 'D.MM.YYYY', locale, true);
    if (!m.isValid()) m = moment(str, 'DD.M.YYYY', locale, true);
    if (!m.isValid()) m = moment(str, 'DD.MM.YYYY', locale, true);
    if (!m.isValid()) m = moment(str, 'M/D/YYYY', locale, true);
    if (!m.isValid()) m = moment(str, 'MM/D/YYYY', locale, true);
    if (!m.isValid()) m = moment(str, 'M/DD/YYYY', locale, true);
    if (!m.isValid()) m = moment(str, 'MM/DD/YYYY', locale, true);
    if (!m.isValid()) m = moment(str, 'YYYY-M-D', locale, true);
    if (!m.isValid()) m = moment(str, 'YYYY-MM-DD', locale, true);

    return m.isValid() ? m.toDate() : undefined;
}

export { customParseDate };